<div mat-dialog-content class="confirm-dialog">
  <div class="content" fxLayout="column" fxLayoutAlign="space-between center">
    <div class="message">{{this.data.message}}</div>
    <div class="action-group" fxLayout="row" fxLayoutAlign="end center">
      <button mat-flat-button color="warn" class="btn-confirm-delete-link" (click)="onConfirmHandler()">Confirm</button>
      <button mat-flat-button (click)="onCancelHandler()">Cancel</button>
    </div>
  </div>
</div>
